import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"
import { Element } from "../element"

// Version 1 ---------------------
export const CardElementV1 = z.object({
  id: z.string(),
  name: z.literal("card"),
  container: ContainerOptionsV1,
  children: z.lazy(() => z.array(Element)),
})

export type TCardElementV1 = z.infer<typeof CardElementV1>

// Latest ---------------------
export const CardElement = CardElementV1
export type TCardElement = TCardElementV1
